import {
  type RouteRecordRaw,
} from 'vue-router'
import DefaultLayout from '@/layout/default/index.vue'
import { findFirstRouteWithPermission } from '../utils'

const OperateRoutes: RouteRecordRaw[] = [
  {
    name: 'Operate',
    path: '/operate',
    redirect: () => {
      return findFirstRouteWithPermission(OperateRoutes[0].children ?? [])
    },
    meta: {
      title: '运营中心',
      order: 4,
    },
    component: DefaultLayout,
    children: [{
      path: 'stores',
      name: 'OperateStores',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '门店管理',
        icon: 'icon-dianpu',
        devUrl: 'http://localhost:8003/shops/list',
        url: `${window.location.origin}/merchant-platform/micro-account/shops/list`,
        isTopLevel: true,
        permission: ['SHOP_QUERY'],
      },
    }, {
      path: 'takeaway',
      name: 'OperateTakeaway',
      redirect: { name: 'OperateMerchantAuthorization' },
      meta: {
        title: '团购外卖',
        icon: 'icon-document-text',
      },
      children: [{
        path: 'merchantAuthorization',
        name: 'OperateMerchantAuthorization',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '商户授权',
          devUrl: 'http://localhost:8003/merchant-management/index',
          url: `${window.location.origin}/merchant-platform/micro-account/merchant-management/index`,
        },
      }, {
        path: 'mapping',
        name: 'OperateMapping',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '门店映射',
          devUrl: 'http://localhost:8003/merchant-management/list',
          url: `${window.location.origin}/merchant-platform/micro-account/merchant-management/list`,
        },
      }],
    }, {
      path: 'OperateOperate',
      name: 'operate',
      meta: {
        title: '行业运营',
        icon: 'icon-qudaoguanli',
      },
      redirect: { name: 'OperateInvCode' },
      children: [{
        path: 'invCode',
        name: 'OperateInvCode',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '邀请码管理',
          devUrl: 'http://localhost:8006/industry/invite-code',
          url: `${window.location.origin}/merchant-platform/micro-industry-center/industry/invite-code`,
          permission: ['INVITATION_CODE_QUERY'],
        },
      }, {
        path: 'partner',
        name: 'OperatePartner',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '合作方管理',
          devUrl: 'http://localhost:8006/industry/partners',
          url: `${window.location.origin}/merchant-platform/micro-industry-center/industry/partners`,
          permission: ['BUSINESS_PARTNER_QUERY'],
        },
      }, {
        path: 'business',
        name: 'OperateBusiness',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '业务员管理',
          devUrl: 'http://localhost:8006/industry/sales',
          url: `${window.location.origin}/merchant-platform/micro-industry-center/industry/sales`,
          permission: ['BUSINESS_PROMOTER_QUERY'],
        },
      }, {
        path: 'team',
        name: 'OperateTeam',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '团队管理',
          devUrl: 'http://localhost:8006/industry/tema',
          url: `${window.location.origin}/merchant-platform/micro-industry-center/industry/tema`,
          permission: ['BUSINESS_TEAM_QUERY'],
        },
      }, {
        path: 'trade',
        name: 'OperateTarde',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '交易查询',
          devUrl: 'http://localhost:8006/industry/trade-query',
          url: `${window.location.origin}/merchant-platform/micro-industry-center/industry/trade-query`,
          permission: ['BUSINESS_TRADE_QUERY'],
        },
      }, {
        path: 'bill',
        name: 'OperateBill',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '交易账单',
          devUrl: 'http://localhost:8006/industry/trade-bill',
          url: `${window.location.origin}/merchant-platform/micro-industry-center/industry/trade-bill`,
          permission: ['BUSINESS_TRADE_BILL_QUERY'],
        },
      }],
    },
    {
      path: 'large-amount',
      name: 'OperateLargeAmount',
      meta: {
        title: '大额收款',
        icon: 'icon-bank-card',
      },
      redirect: { name: 'OperateLargeAmountPayer' },
      children: [
        {
          path: 'payer',
          name: 'OperateLargeAmountPayer',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '付款方管理',
            devUrl: 'http://localhost:8006/large-amount',
            url: `${window.location.origin}/merchant-platform/micro-industry-center/large-amount`,
            permission: ['LARGE_PAYMENT_PAYER_QUERY'],
          },
        },
        {
          path: 'payee',
          name: 'OperateLargeAmountPayee',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '收款方名称管理',
            devUrl: 'http://localhost:8006/large-amount/payee',
            url: `${window.location.origin}/merchant-platform/micro-industry-center/large-amount/payee`,
            permission: ['LARGE_PAYMENT_PAYEE_QUERY'],
          },
        },
        {
          path: 'members',
          name: 'OperateLargeAmountMembers',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '成员管理',
            devUrl: 'http://localhost:8006/large-amount/members',
            url: `${window.location.origin}/merchant-platform/micro-industry-center/large-amount/members`,
            permission: ['LARGE_PAYMENT_EMPLOYEE_QUERY'],
          },
        },
        {
          path: 'orders',
          name: 'OperateLargeAmountOrders',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '收款单查询',
            devUrl: 'http://localhost:8006/large-amount/orders',
            url: `${window.location.origin}/merchant-platform/micro-industry-center/large-amount/orders`,
            permission: ['PAYEE_DATA_QUERY'],
          },
        },
        {
          path: 'transfers',
          name: 'OperateLargeAmountTransfers',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '对账明细',
            devUrl: 'http://localhost:8006/large-amount/transfers',
            url: `${window.location.origin}/merchant-platform/micro-industry-center/large-amount/transfers`,
            permission: ['TANS_DATA_QUERY'],
          },
        },
      ],
    },
    {
      path: 'group-merchant',
      name: 'OperateGroupMerchant',
      meta: {
        title: '总部商户管理',
        icon: 'icon-document-text',
      },
      redirect: { name: 'OperateGroupMerchantSub' },
      children: [
        {
          path: 'sub',
          name: 'OperateGroupMerchantSub',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '子商户管理',
            devUrl: 'http://localhost:8007/group-merchant/sub',
            url: `${window.location.origin}/merchant-platform/micro-group/group-merchant/sub`,
            permission: ['OFFICE_MERCHANT_QUERY'],
          },
        },
        {
          path: 'tier',
          name: 'OperateGroupMerchantTier',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '层级管理',
            devUrl: 'http://localhost:8007/group-merchant/tier',
            url: `${window.location.origin}/merchant-platform/micro-group/group-merchant/tier`,
            permission: ['OFFICE_LEVEL_QUERY'],
          },
        },
        {
          path: 'sub-terminal',
          name: 'OperateGroupMerchantSubTerminal',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '机具详情',
            hidden: true,
            devUrl: 'http://localhost:8003/group-merchant/sub-terminal',
            url: `${window.location.origin}/merchant-platform/micro-account/group-merchant/sub-terminal`,
            permission: ['OFFICE_MERCHANT_TERMINAL_QUERY'],
          },
        }],
    },
    {
      path: 'pay-template',
      name: 'OperatePayTemplate',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '表单支付',
        icon: 'icon-jiaoyichaxun',
        isTopLevel: true,
        devUrl: 'http://localhost:8006/template/pay-template',
        url: `${window.location.origin}/merchant-platform/micro-industry-center/template/pay-template`,
        permission: ['TRADE_PLAN_QUERY'],
      },
    }, {
      path: 'fully-digitalized-electronic-invoice',
      name: 'OperateFullyDigitalizedElectronicInvoice',
      redirect: { name: 'OperateElectronicInvoice' },
      meta: {
        title: '数电发票',
        icon: 'icon-document-text',
      },
      children: [
        {
          path: 'electronic-invoice',
          name: 'OperateElectronicInvoice',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '电票助手',
            devUrl: 'http://localhost:8003/electronic-invoice/index',
            url: `${window.location.origin}/merchant-platform/micro-account/electronic-invoice/index`,
          },
        },
        {
          path: 'invoice-verification',
          name: 'OperateInvoiceVerification',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '发票查验',
            link: 'https://inv-veri.chinatax.gov.cn/',
          },
        },
        // {
        //   path: 'jia-you-ba-index',
        //   name: 'JiaYouBaIndex',
        //   component: () => import('@/views/wujie.vue'),
        //   meta: {
        //     title: '交易查询',
        //     devUrl: 'http://localhost:8003/jia-you-ba/index',
        //     url: `${window.location.origin}/merchant-platform/micro-account/jia-you-ba/index`,
        //   },
        // },
        // {
        //   path: 'jia-you-ba-invoice',
        //   name: 'JiaYouBaInvoice',
        //   component: () => import('@/views/wujie.vue'),
        //   meta: {
        //     title: '开票确认',
        //     devUrl: 'http://localhost:8003/jia-you-ba/invoice',
        //     url: `${window.location.origin}/merchant-platform/micro-account/jia-you-ba/invoice`,
        //   },
        // },
      ],
    },

    // {
    //   path: 'wages',
    //   name: 'OperateWages',
    //   meta: {
    //     title: '灵活发薪',
    //     icon: 'icon-currency-yen',
    //   },
    //   children: [
    //     {
    //       path: 'batch',
    //       name: 'OperateWagesBatch',
    //       meta: {
    //         title: '批量发薪',
    //         link: `${window.location.origin}/user.html#/flexible/batch`,
    //       },
    //     }, {
    //       path: 'record',
    //       name: 'OperateWagesBatchRecord',
    //       meta: {
    //         title: '批次记录',
    //         link: `${window.location.origin}/user.html#/flexible/batchRecord`,
    //       },
    //     }, {
    //       path: 'batchDetail',
    //       name: 'OperateWagesBatchDetail',
    //       meta: {
    //         title: '批次明细',
    //         link: `${window.location.origin}/user.html#/flexible/batchDetail`,
    //       },
    //     }, {
    //       path: 'limit',
    //       name: 'OperateLimit',
    //       meta: {
    //         title: '个人额度',
    //         link: `${window.location.origin}/user.html#/flexible/batchLimit`,
    //       },
    //     }, {
    //       path: 'refundTicket',
    //       name: 'OperateRefundTicket',
    //       meta: {
    //         title: '退票查询（还没做）',
    //       },
    //     }],
    // },
    {
      path: 'terminal',
      name: 'Terminal',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '收银机具管理',
        icon: 'icon-shebei',
        devUrl: 'http://localhost:8003/terminal',
        url: `${window.location.origin}/merchant-platform/micro-account/terminal`,
        isTopLevel: true,
        permission: ['MCH_PAYEE_QRCODE_QUERY', 'MCH_POS_QUERY', 'MCH_LOUDSPEAKER_QUERY', 'MCH_SCANNER_QUERY', 'MCH_PRINTER_QUERY'],
      },
    },
    ],
  },
]

export default OperateRoutes
